import "../Css/Notifications.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CallInfoNotification from "./CallInfoNotification";
import { ListenToEventSource, askNotificationPermission } from "../store/api/CommonFunctions";
import PhoneRingtone from "../content/PhoneRingtone.mp3"
import { Button } from "react-bootstrap";
import TicketNotification from "./TicketNotification";
import { useDispatch } from "react-redux";

let notificationArchive = [];
const guaranteeExpLines = [{
    text: "با تمدید پشتیبانی، همچنان از خدمات تخصصی و به‌روزرسانی‌های بی‌همتا بهره‌مند خواهید بود.", style: {}
},
{ text: "### مزایای تمدید پشتیبانی", style: { fontWeight: "700", marginTop: "8px", marginBottom: "8px" } },
{ text: "- دریافت نسخه‌های جدید، به‌روزرسانی‌ها و اصلاحیه‌های نرم‌افزار", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- بهره‌مندی از خدمات رفع اشکالات فنی و نرم‌افزاری", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- دریافت راهنمایی و پاسخ‌گویی کارشناسان پشتیبانی", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- ثبت تیکت و پیگیری درخواست‌ها", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- دریافت آموزش و راهنمای استفاده از امکانات نرم‌افزار", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- اطلاع از قابلیت‌ها و خدمات جدید بی‌همتا", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "### در صورت عدم تمدید پشتیبانی", style: { fontWeight: "700", marginTop: "8px", marginBottom: "8px" } },
{ text: "- خدمات پشتیبانی کارشناسان مطابق قرارداد در دسترس نخواهد بود.", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- درخواست‌های فنی و آموزشی، در صورت امکان و با توافق طرفین، به‌صورت موردی و با هزینه جداگانه قابل انجام خواهند بود.", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- به‌روزرسانی‌ها و اصلاحیه‌های منتشرشده در دوره عدم پشتیبانی در اختیار شما قرار نخواهند گرفت.", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- رسیدگی به درخواست‌های جدید، منوط به بررسی، امکان‌سنجی و توافق درباره هزینه خدمات خواهد بود.", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "نکته مهم: مجوز دائمی استفاده از نرم‌افزار شما همچنان معتبر است. عدم تمدید پشتیبانی، موجب غیرفعال شدن نرم‌افزار یا از بین رفتن اطلاعات شما نمی‌شود.", style: { marginTop: "5px" } },
{ text: "### برای تمدید یا دریافت راهنمایی با ما در ارتباط باشید:", style: { marginTop: "8px", marginBottom: "8px", fontWeight: "700" } },
{ text: "- سامانه پشتیبانی: ثبت تیکت در سامانه بی‌همتا", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- تماس تلفنی: 02177613024", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- واتساپ: 09213979624", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "- وب‌سایت: https://bihamta.hoormah.com", style: { paddingRight: "5px", fontSize: "12px" } },
{ text: "بی‌همتا؛ همراه کسب‌وکار شما", style: { marginTop: "8px", marginBottom: "8px", fontWeight: "700" } },
{ text: "برای تداوم بهره‌مندی از خدمات پشتیبانی و به‌روزرسانی‌ها، همین امروز پشتیبانی نرم‌افزار خود را تمدید کنید.", style: {} }

]
const NotificationArea = ({ setModalGuarantee }) => {

    const history = useHistory();
    let [notifCount, setNotifications] = useState(notificationArchive.length);
    const callInfoNotifs = notificationArchive ? notificationArchive.sort((a, b) => b.ID - a.ID).filter(n => n.Type.includes("callinfo")) : [];
    const ticketNotifications = notificationArchive ? notificationArchive.sort((a, b) => b.ID - a.ID).filter(n => n.Type.includes("NewTicket")) : [];
    const onGetNotify = (notif) => {
        try {
            const notifJson = JSON.parse(notif);
            if (notifJson.Type !== "gExp" && notifJson.Type !== "Subsc")
                notificationArchive.push(notifJson);
            setNotifications(notificationArchive.length);
            if ('Notification' in window) {
                if (notifJson.Type.includes("callinfo")) {
                    const n = new Notification('تماس جدید',
                        {
                            body: notifJson.Name + "\n" + "شماره تماس: " + notifJson.CallNumber,
                            icon: "../content/images/circle.png"
                        });
                }
                else if (notifJson.Type.includes("NewTicket")) {
                    const title = notifJson.Type === "NewTicket" ? "تیکت جدید" : "پاسخ به تیکت";
                    const n = new Notification(title,
                        {
                            body: "شناسه تیکت: " + notifJson.TicketID + "\n" + "نام مشتری: " + notifJson.CustomerName,
                            icon: "../content/images/circle.png"
                        });
                }
                else if (notifJson.Type === "gExp") {
                    if (notifJson.AlertType === "modal") {
                        //setErrorDialog(dispatch, notifJson.Text, "گارانتی محصول");
                        localStorage.setItem("GUARANTEE_NOTIF", JSON.stringify(notifJson));
                        setModalGuarantee({
                            show: true,
                            delayedClose: true,
                            moreLines: guaranteeExpLines,
                            ...notifJson,

                        })
                    }
                    else {
                        const n = new Notification("گارانتی محصول",
                            {
                                body: notifJson.Text,
                                icon: "../content/images/circle.png"
                            });
                    }

                }
            }


            else {
                var audio = new Audio(PhoneRingtone);
                audio.play();
            }
        }
        catch (er) {
            console.error("onGetNotify:", er.message ?? er);
        }
    }
    useEffect(() => {
        askNotificationPermission();
        ListenToEventSource(onGetNotify);
        const guaranteeNotif = localStorage.getItem("GUARANTEE_NOTIF");
        if (guaranteeNotif) {
            const notifObj = JSON.parse(guaranteeNotif)
            setModalGuarantee({
                show: true,
                delayedClose: true,
                moreLines: guaranteeExpLines,
                ...notifObj,

            })
        }
    }, []);
    const removeNotification = (id) => {
        notificationArchive = notificationArchive.filter(n => n.ID !== id);
        setNotifications(notificationArchive.length);
    }
    function clearAll() {
        notificationArchive = [];
        setNotifications(0);
    }
    const openProfile = (id, type) => {
        history.push(getDestUrl(id, type));
    }
    function getDestUrl(id, type) {

        if (type === "customer_callinfo" || type.includes("NewTicket")) {
            return `/CRM/AddEditCustomer/${id}`;
        }
        const urlMap = {
            "precustomer_callinfo": `/CRM/AddEditPreCustomer/${id}`,
            "staff_callinfo": `/Services/AddEditStaff/false/${id}`,
            "agent_callinfo": `/Services/AddEditStaff/true/${id}`,
            "personnel_callinfo": `/BaseInfo/AddEditPersonnel/${id}`
        };
        return urlMap[type] || "";
    }
    return (


        <div className="notificationArea">
            <input type="hidden" readOnly value={notifCount} />
            {callInfoNotifs && Array.isArray(callInfoNotifs) &&
                callInfoNotifs.map((notif, i) =>
                    <CallInfoNotification notif={notif} key={i} remove={removeNotification} openProfile={openProfile} getDestUrl={getDestUrl} />)
            }
            {ticketNotifications &&
                ticketNotifications.map((notif, i) =>
                    <TicketNotification notif={notif} key={i} remove={removeNotification} openProfile={openProfile} getDestUrl={getDestUrl} />)
            }
            {notifCount > 0 &&
                <div>
                    <Button variant="info" className="group-Btn-smalll" onClick={clearAll}>پاک کردن همه</Button>
                </div>
            }
        </div>
    )
}
export default NotificationArea;